// @flow
export const constructGraphqlError = (e: string): Promise<*> =>
  Promise.reject({
    graphQLErrors: [{ message: "Passwords must be same" }],
  })



// WEBPACK FOOTER //
// ./src/common/graphql/errors.js